import React from 'react';
import { Button } from '@brighterion/br-ui';
import EllipsisTooltip from 'Components/EllipsisTooltip';
import clsx from 'clsx';
import useBreadcrumbs from 'Hooks/useBreadcrumbs';
import { useTranslation } from 'react-i18next';
import { generatePath, useHistory } from 'react-router-dom';

import styles from './Breadcrumbs.css';

export const Breadcrumbs = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const { breadcrumbs } = useBreadcrumbs() as BreadcrumbWrapper;

    const renderEllipText = (title: string, defaultCursor?: boolean) => {
        return (
            <EllipsisTooltip
                text={title}
                className={clsx(styles.ellipText, styles.flexMaxWidth)}
                defaultCursor={defaultCursor}
            />
        );
    };
    return (
        <span className={clsx(styles.breadcrumbsContainer, styles.flex)}>
            {breadcrumbs.map((breadcrumb: Breadcrumb, index: number) => {
                const isLastBreadcrumb = index === breadcrumbs?.length - 1;
                const title = t(breadcrumb?.title, { ...breadcrumb?.params });
                return (
                    <div className={styles.flex} key={`${breadcrumb.title}`}>
                        {isLastBreadcrumb ? (
                            <div data-testid={`${title}-breadcrumb`}>{renderEllipText(String(title), true)}</div>
                        ) : (
                            <Button
                                variant='tertiary'
                                className={styles.breadcrumbLink}
                                dataTestId={`${title}-breadcrumb`}
                                clickCallback={() => {
                                    const linkToVisit = generatePath(breadcrumb.providedPath, {
                                        ...breadcrumb?.params
                                    });
                                    history.push(linkToVisit);
                                }}
                            >
                                {renderEllipText(String(title))}
                            </Button>
                        )}
                        {!isLastBreadcrumb && <div className={styles.breadcrumbDivider}>/</div>}
                    </div>
                );
            })}
        </span>
    );
};

export default Breadcrumbs;
